import $ from 'jquery';

class Accommodation {
  constructor() {
    this.accordion = $('.js-accordion');

    if (!this.accordion.length) {
      return;
    }

    this.selectors = {
      question: '.js-accordion-question',
      button: '.js-accordion-button',
    };

    this.init();
    this.hashHandler();
    this.anchorHandler();
    $(window).on('hashchange', () => {
      this.hashHandler();
    });
  }

  anchorHandler() {
    $('a').on('click', e => {
      const link = e.currentTarget;
      const href = link.getAttribute('href');

      if (href.substring(0, 1) === '#') {
        const question = $(`${this.selectors.question}${href}`);

        if (question.length) {
          e.preventDefault();
          window.location.hash = href;

          if (!question.hasClass('is-active')) {
            question.find(this.selectors.button).trigger('click');
          }

          $('html, body')
            .stop()
            .animate(
              {
                scrollTop: question.offset().top - 150,
              },
              500,
            );
        }
      }
    });
  }

  hashHandler() {
    const { hash } = window.location;

    if (hash) {
      const question = $(`${this.selectors.question}${hash}`);

      if (question.length) {
        if (!question.hasClass('is-active')) {
          question.find(this.selectors.button).trigger('click');
        }

        $(window).scrollTop(0);
        $('html, body')
          .stop()
          .animate(
            {
              scrollTop: question.offset().top - 150,
            },
            500,
          );
      }
    }
  }

  init() {
    $.each(this.accordion, (i, el) => {
      const accordion = $(el);
      const button = accordion.find('.js-accordion-button');
      const initColor = button.parent().attr('data-color');

      button
        .parent()
        .on('mouseenter', e => {
          const colorHover = $(e.currentTarget).attr('data-color-active');
          $(e.currentTarget).css({
            color: colorHover,
          });
          $(e.target).css({
            fill: colorHover,
          });
        })
        .on('mouseleave', e => {
          if (!$(e.currentTarget).hasClass('is-active')) {
            $(e.currentTarget).css({ color: initColor });
            $(e.target).css({ fill: initColor });
          }
        });

      button.on('click', e => {
        const self = $(e.currentTarget);
        const content = self
          .closest('.js-accordion-item')
          .find('.js-accordion-answer');

        if (self.parent().hasClass('is-active')) {
          self.css({
            fill: initColor,
          });
          self.parent().css({
            color: initColor,
          });
          content.slideUp(300, () => {
            content.removeClass('is-active');
            self.parent().removeClass('is-active');
          });
        } else {
          const colorHover = self.parent().attr('data-color-active');

          self.css({
            fill: colorHover,
          });
          self.parent().css({
            color: colorHover,
          });

          content.slideDown(300, () => {
            content.addClass('is-active');
            self.parent().addClass('is-active');
          });
        }
      });
    });
  }
}

export default new Accommodation();



// WEBPACK FOOTER //
// ./src/scripts/modules/accordion.js